import React from "react";
import EquityLogo from "@/components/EquityLogo";

const DOT_COUNT = 12;
const CYCLE_MS = 1100; // one full rotation feels brisk — reads as "loading fast", not sluggish

// Branded in-app loading state — logo centered inside a ring of dots that chase around
// it (the classic native-app activity-indicator look), no text. Used for every full-page/
// full-sheet load (dashboard, document print, approval preview, etc.) instead of a bare
// spinner icon. Logo via EquityLogo (a cropped <img>, not a blend-mode trick) so it renders
// correctly on both light (e.g. the white print page) and dark backgrounds.
export default function PageLoader({ fullScreen = false, className = "" }) {
  return (
    <div className={`flex items-center justify-center ${fullScreen ? "min-h-screen" : "py-20"} ${className}`}>
      <div className="relative" style={{ width: 64, height: 64 }}>
        {Array.from({ length: DOT_COUNT }).map((_, i) => {
          const angle = (360 / DOT_COUNT) * i;
          const delay = (CYCLE_MS / DOT_COUNT) * i;
          return (
            <span
              key={i}
              className="absolute rounded-full bg-blue-500"
              style={{
                width: 5, height: 5, top: "50%", left: "50%",
                transform: `rotate(${angle}deg) translate(26px) rotate(-${angle}deg)`,
                marginTop: -2.5, marginLeft: -2.5,
                animation: `eq-loader-pulse ${CYCLE_MS}ms linear infinite`,
                animationDelay: `${delay}ms`,
              }}
            />
          );
        })}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-8 h-8 rounded-lg overflow-hidden bg-[#020617] flex items-center justify-center shrink-0">
            <EquityLogo size={32} />
          </div>
        </div>
      </div>
      <style>{`@keyframes eq-loader-pulse { 0% { opacity: 1 } 100% { opacity: 0.15 } }`}</style>
    </div>
  );
}
